import { NgModule } from '@angular/core';
import { FavoritesService, ProfilesService, StreamsService } from '@kitch/data-access/services';
import { UserSharedModule } from '@kitch/user/shared/user-shared.module';
import { UiModule } from '@kitch/ui';
import { userFavoritesComponents } from './components/index';
import { MyFavoritesRoutingModule } from './favorites-routing.module';

@NgModule({
  declarations: [...userFavoritesComponents],
  imports: [UserSharedModule, MyFavoritesRoutingModule, UiModule],
  providers: [FavoritesService, StreamsService, ProfilesService],
})
export class FavoritesModule {}
